import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '../assets/table-empty.svg'


const _hoisted_1 = {
  id: "cari-stt-scan",
  class: "w-full h-full bg-gray-lp-200 flex flex-col overflow-auto"
}
const _hoisted_2 = { class: "flex items-center gap-x-5 text-black-lp-200 py-5 border-t border-gray-lp-1400" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 cursor-pointer",
  alt: "back"
}, null, -1)
const _hoisted_4 = { class: "p-4" }
const _hoisted_5 = { class: "w-full flex flex-col gap-y-2 p-4 bg-white rounded-lg" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col gap-y-2 items-center justify-center w-full",
  style: {"height":"316px"}
}
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  style: {"width":"160px"},
  alt: "table-empty"
}, null, -1)
const _hoisted_8 = { class: "text-gray-lp-800 text-sm text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchSttScanComponent = _resolveComponent("SearchSttScanComponent")!
  const _component_ScanFilterComponent = _resolveComponent("ScanFilterComponent")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Print = _resolveComponent("Print")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: ["bg-white w-full text-xl font-semibold border-b border-gray-lp-1400 px-3", _ctx.isSidebarAndBreadcrumbV2 ? '' : 'pt-3']
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("button", {
            class: "outline-none",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, [
            _hoisted_3
          ]),
          _createVNode("span", null, _toDisplayString(_ctx.$t("cariStt.scanPageTitle")), 1)
        ])
      ], 2),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_SearchSttScanComponent, {
            latestSttData: _ctx.latestSttData,
            onSuccess: _ctx.onSuccessScan
          }, null, 8, ["latestSttData", "onSuccess"]),
          _createVNode(_component_ScanFilterComponent, {
            disabled: !_ctx.dataTable.data.length,
            onFilter: _ctx.getSearchSttScanList,
            onSubmit: _ctx.onProcessManifest
          }, null, 8, ["disabled", "onFilter", "onSubmit"]),
          (!_ctx.dataTable.data.length)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _hoisted_7,
                _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("cariStt.scanEmptyState")), 1)
              ]))
            : (_openBlock(), _createBlock(_component_Table, {
                key: 1,
                summary: _ctx.dataTable.summary,
                data: _ctx.dataTable.data
              }, null, 8, ["summary", "data"]))
        ])
      ])
    ]),
    _createVNode(_component_Print, { ref: "search-stt-scan-print" }, null, 512)
  ], 64))
}